// src/pages/SecurityPage.jsx
// Security (3.49.0, Super Admins only): its own page in the left strip's
// Super Admin group, out of the Console. Sections, each with its address:
//   /portal/security/refused-emails       emails from people who can't fax
//   /portal/security/blocked-senders      senders who no longer get notices
//   /portal/security/blocked-connections  robot requests that failed the key
//                                         or signature check
//   /portal/security/ip-blocking          blocked and allowed IP addresses,
//                                         failed sign-ins and the rules
// The old Console addresses (/console/refused-emails…) still open it.
import SectionTabs from '../components/SectionTabs';
import { RejectedEmails, BlockedSenders, BlockedRequests } from './RejectedLogs';
import IpBlocking from './IpBlocking';
import { pathForTab } from '../utils/tabRoutes';

export const SECURITY_SECTIONS = [
  { id: 'refused-emails',      label: 'Refused Emails',      icon: '🚫' },
  { id: 'blocked-senders',     label: 'Blocked Senders',     icon: '🚷' },
  { id: 'blocked-connections', label: 'Blocked Connections', icon: '🔌' },
  { id: 'ip-blocking',         label: 'IP Blocking',         icon: '⛔' },
];
const ALIASES = { 'rejected-emails': 'refused-emails', 'blocked-requests': 'blocked-connections' };

function openSection(id) {
  window.history.pushState({ tab: 'security', sub: id }, '', `${pathForTab('security')}/${id}`);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export default function SecurityPage() {
  return (
    <SectionTabs tabId="security" title="🔒 Security" sections={SECURITY_SECTIONS} aliases={ALIASES}
      about="What the portal refused or blocked: emails from people who can't send faxes, senders who no longer get notices, connections that failed the security check, and IP addresses blocked for failed sign-ins or too many requests.">
      {sub => (
        <>
          {sub === 'refused-emails' && <RejectedEmails onOpenBlocked={() => openSection('blocked-senders')} />}
          {sub === 'blocked-senders' && <BlockedSenders />}
          {sub === 'blocked-connections' && <BlockedRequests />}
          {sub === 'ip-blocking' && <IpBlocking />}
        </>
      )}
    </SectionTabs>
  );
}
